export default __webpack_public_path__ + "static/media/sprite.07744691.svg";